<template>
<!-- 阅卷老师管理 列表页 -->
    <div class="board">
        <div>
            <div class="title">
                <span class="name">{{ reviewerTextConfig.title }}</span>

                <div>
                    <el-button type="primary" @click="openAddDialog" v-has-permi="['tipdm:user:add']">{{ buttonTextConfig.add.name }}</el-button>
                    <el-button type="primary" @click="openUploadDialog" v-has-permi="['tipdm:user:add']">批量导入</el-button>
<!--                    <el-button type="primary" @click="importDialogVisible = true" v-hasPermi="['tipdm:user:import']">上传人脸照片</el-button>-->
                </div>
            </div>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item>
                    <el-input v-model="searchForm.username" clearable :placeholder="searchTextConfig.username"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchForm.realname" clearable :placeholder="searchTextConfig.realname"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchForm.phone" clearable :placeholder="searchTextConfig.phone"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchForm.email" clearable :placeholder="searchTextConfig.email"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                stripe
                size="medium">
                <!-- 列表显示小图，鼠标悬停（鼠标移入图片上方1秒时）显示大图。 -->
<!--                <el-table-column-->
<!--                    prop="faceImg"-->
<!--                    width="70px"-->
<!--                    align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-popover-->
<!--                            v-if="scope.row.faceImg"-->
<!--                            placement="bottom-start"-->
<!--                            trigger="hover"-->
<!--                            :open-delay="1000"-->
<!--                            :close-delay="100"-->
<!--                            append-to-body-->
<!--                            :visible-arrow="false"-->
<!--                            popper-class="teacher-face-img-popover">-->
<!--                            <img :src="scope.row.faceImg" class="teacher-face-img-large" />-->
<!--                            <img slot="reference" :src="scope.row.faceImg" class="face-img-small" />-->
<!--                        </el-popover>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                    prop="username"
                    :label="tableTextConfig.username">
                </el-table-column>
                <el-table-column
                    prop="realname"
                    :label="tableTextConfig.realname">
                </el-table-column>
                <el-table-column
                    :label="tableTextConfig.idCardNo"
                    min-width="150px"
                    show-overflow-tooltip>
                    <template slot-scope="scope">	
                        <span>{{scope.row.idCardNo}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="phone"
                    :label="tableTextConfig.phone">
                </el-table-column>
                <el-table-column
                    prop="email"
                    :label="tableTextConfig.email">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    :label="tableTextConfig.createTime">
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="260px">
                    <template slot-scope="scope">
                        <el-button @click="openEditDialog(scope.row)" v-has-permi="['tipdm:user:edit']">{{ buttonTextConfig.edit.name }}</el-button>
                        <el-button @click="openChangePwdDialog(scope.row)" v-has-permi="['tipdm:user:changePwd']">{{ buttonTextConfig.changePwd.name }}</el-button>
                        <el-button @click="removeUser(scope.row.id)" v-has-permi="['tipdm:user:remove']">{{ buttonTextConfig.remove.name }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                v-show="tableData.length"
                :currentPage.sync="searchForm.pageNumber"
                :pageSize.sync="searchForm.pageSize"
                :total.sync="total">
            </pagination>
        </div>

        <add ref="addDialog" @success="search(1)"></add>
        <upload ref="uploadDialog" @success="search(1)"></upload>
        <edit :user="user" ref="editDialog" @success="search(1)"></edit>
        <changePwd :user="user" ref="changePwdDialog" @success="search(1)"></changePwd>
<!--        <import-dialog :show.sync="importDialogVisible" @close="close"></import-dialog>-->
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {findUserPage, removeUser} from "@/api/user";
import add from "@/views/teacher/add.vue";
import edit from "@/views/teacher/edit.vue";
import changePwd from "@/views/teacher/changePwd.vue";
import upload from "@/views/teacher/upload.vue";
// 引入上传人脸照片弹窗
// import importDialog from "@/views/teacher/dialog/batchImportTeacherFace.vue";
export default {
    components: {
        pagination,
        add,
        edit,
        changePwd,
        upload,
        // importDialog
    },
    data() {
        return {
            loading: true,
            searchForm: {
                username: null,
                realname: null,
                phone: null,
                email: null,
                pageNumber: 1,
                pageSize: 20
            },
            user: null,
            total: 0,
            tableData: [],
            // importDialogVisible: false
        }
    },
    computed: {
        reviewerTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer
        },
        searchTextConfig() {
            return this.reviewerTextConfig.search
        },
        tableTextConfig() {
            return this.reviewerTextConfig.table
        },
        buttonTextConfig() {
            return this.reviewerTextConfig.button
        }
    },
    created() {
        this.search(1)
    },
    methods: {
        search(val) {
            this.loading = true
            if (val) {
                this.searchForm.pageNumber = val
            }
            findUserPage(this.searchForm).then(res => {
                this.tableData = res.data.content
                this.total = res.data.totalElements
            }).finally(() => {
                this.loading = false
            })
        },
        reset() {
            this.searchForm = {
                username: null,
                realname: null,
                phone: null,
                email: null,
                pageNumber: 1,
                pageSize: 20
            }
            this.search(1)
        },
        openAddDialog() {
            this.$refs.addDialog.open()
        },
        openEditDialog(row) {
            this.user = Object.assign({}, row)
            this.$refs.editDialog.open()
        },
        openChangePwdDialog(row) {
            this.user = Object.assign({}, row)
            this.$refs.changePwdDialog.open()
        },
        removeUser(id) {
            let textConfig = this.buttonTextConfig.remove
            this.$confirm(textConfig.message, textConfig.title, {
                confirmButtonText: textConfig.ok,
                cancelButtonText: textConfig.cancel,
                type: 'warning'
            }).then(() => {
                removeUser(id).then(res => {
                    if (res.status === 200) {
                        this.search(1)
                        this.$message.success(textConfig.success)
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(err => {
                    this.$message.error(err.message)
                })
            })
        },
        openUploadDialog() {
            this.$refs.uploadDialog.open()
        },
        close() {
            // this.importDialogVisible = false;
            this.search(1)
        }
    }
}
</script>

<!--<style scoped>-->
<!--//.face-img-small {-->
<!--//    height: 50px;-->
<!--//    width: auto;-->
<!--//    cursor: pointer;-->
<!--//    border-radius: 4px;-->
<!--//    display: inline-block;-->
<!--//}-->
<!--</style>-->
<!--<style>-->
<!--/* append-to-body 的浮层不在当前组件根下，需非 scoped */-->
<!--.teacher-face-img-popover.el-popover {-->
<!--    width: auto !important;-->
<!--    min-width: 0;-->
<!--    padding: 4px;-->
<!--    box-sizing: border-box;-->
<!--}-->
<!--.teacher-face-img-large {-->
<!--    height: 160px;-->
<!--    width: auto;-->
<!--    display: block;-->
<!--    border-radius: 4px;-->
<!--    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);-->
<!--    border: 2px solid #fff;-->
<!--}-->
<!--</style>-->
